import Mixin from 'mixmatch';
import Page from '../page';

const DEFAULT_PER_PAGE = 1000;

export default class List extends Mixin {
  get defaultListParams() {
    return { per_page: DEFAULT_PER_PAGE };
  }

  async all(params) {
    const options = {
      method: 'GET',
      // @ts-ignore
      path: this.collection(),
      qs: params || this.defaultListParams,
    };

    // @ts-ignore
    const body = await this.call(options);

    // @ts-ignore
    return new Page(JSON.parse(body), this.resourcesName);
  }
}
